var exports = module.exports;
exports.toJson = require('./xml2json');
exports.toXml = require('./json2xml');